import { ClientModel } from '../ts/interfaces/models/ClientModel';
import { BaseService } from './baseService';

class ClientService extends BaseService<ClientModel> {
  controllerName = 'client';
}

export const clientService = new ClientService();
